import { Link } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';

import { isVideoUrl } from "../cloudinaryConfig";
import { useAuth } from "../AuthContext";

export default function ProductCard({ product }) {
  const { isLoggedIn } = useAuth();

  const imagesRaw = product?.images ?? product?.image ?? null;
  const images = Array.isArray(imagesRaw)
    ? imagesRaw
    : imagesRaw
      ? [imagesRaw]
      : [];

  const mainImg = images.find(img => !isVideoUrl(img)) || (images.length > 0 ? images[0] : "");
  const isVideo = isVideoUrl(mainImg);

  // Price calculation
  const price = product?.price;
  const offer = product?.offer || 0;
  const discountedPrice = price ? Math.round(price * (1 - offer / 100)) : null;

  return (
    <Link
      to={`/product/${product?.id}`}
      className="product-card-link link-clean"
    >
      <div className="product-card">
        <div className="product-media">
          {mainImg ? (
            isVideo ? (
              <video
                src={mainImg}
                alt={product?.name}
                muted
                loop
                autoPlay
                playsInline
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <img src={mainImg} alt={product?.name} />
            )
          ) : (
            <div className="product-card-placeholder" />
          )}
        </div>
        <div className="product-body">
          {product?.category && (
            <div className="product-category">{product.category}</div>
          )}
          <div className="product-title text-dark">{product?.name || "Product"}</div>

          {/* Price Section — Only for logged in users */}
          {price != null && (
            <div className="product-price-row">
              {isLoggedIn ? (
                <>
                  <span className="price-current">₹{discountedPrice || price}</span>
                  {offer > 0 && (
                    <>
                      <span className="price-old">₹{price}</span>
                      <span className="price-offer">{offer}% off</span>
                    </>
                  )}
                </>
              ) : (
                <span className="price-login-hint">
                  <FaLock size={10} /> Login to see price
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
